import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import PromoPopup from "./PromoPopup";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-bone">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <PromoPopup />
    </div>
  );
}
